import { render, staticRenderFns } from "./TagDisplay.vue?vue&type=template&id=201e5be0&scoped=true&"
import script from "./TagDisplay.vue?vue&type=script&lang=js&"
export * from "./TagDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TagDisplay.vue?vue&type=style&index=0&id=201e5be0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e5be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201e5be0')) {
      api.createRecord('201e5be0', component.options)
    } else {
      api.reload('201e5be0', component.options)
    }
    module.hot.accept("./TagDisplay.vue?vue&type=template&id=201e5be0&scoped=true&", function () {
      api.rerender('201e5be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/TagDisplay.vue"
export default component.exports